export default __webpack_public_path__ + "static/media/delete-icon.29855f39.svg";